





















import { Component, Vue } from 'vue-property-decorator';
import { HomeService } from '../api/home';
import global from '../utils/global';

@Component({})
export default class CourseBookList extends Vue {
  private service: HomeService = new HomeService();
  private courseData: any[] = [];
  private bookData: any[] = [];
  private imgUrl: string = `${global.BACKGROUND_URL}/book/`;
  private mounted() {
    console.log(global.getToken());
    this.service.Course(10).then((response: any) => {
      this.courseData = response;
    });
    this.service.Book(0, 10).then((response: any) => {
      this.bookData = response;
    });
  }
  private course_OnClick(courseId: number) {
    this.$router.push({name: 'book', query: {id: courseId.toString()}});
  }
  private book_OnClick(bookId: number) {
    this.$router.push({name: 'file', query: {id: bookId.toString()}});
  }
}
